import { execute, addQueryParams } from '@/api/utils'
import { GET, POST, PUT, DELETE } from '@/api/types'

export default {
  list (farmID, params = {}) {
    return execute(GET, addQueryParams(`farms/${farmID}/rations`, params))
  },

  create (farmID, payload) {
    return execute(POST, `farms/${farmID}/rations`, payload)
  },

  updateById (farmID, id, payload) {
    return execute(PUT, `farms/${farmID}/rations/${id}`, payload)
  },

  getById (farmID, id) {
    return execute(GET, `farms/${farmID}/rations/${id}`)
  },

  deleteById (farmID, id) {
    return execute(DELETE, `farms/${farmID}/rations/${id}`)
  },

  getRecipes (farmID, rationID, params = {}) {
    return execute(GET, addQueryParams(`farms/${farmID}/rations/${rationID}/recipes`, params))
  }
}
